"use strict";
exports["-68cdfd15"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizCopilotServiceNowConnectorDiagnosticTitleText","description":"WizCopilotServiceNowConnectorDiagnosticDescText","properties":{"connectorType":{"type":"string","title":"LabelConnectorType","default":"KB","enum":["KB","Catalog","Tickets"],"enumNames":["ServiceNow KB","ServiceNow Catalog","ServiceNow Tickets"]},"authenticationType":{"type":"string","title":"LabelAuthenticationType","default":"Basic","enum":["Basic","OAuth"],"enumNames":["AuthenticationTypeBasic","AuthenticationTypeOAuth"]},"serviceNowUrl":{"type":"string","title":"ServiceNowUrlInstanceLabel","pattern":"^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$"},"userName":{"type":"string","title":"LabelSourceUserName","pattern":"^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$"},"password":{"type":"string","title":"LabelPassword"},"apiName":{"type":"string","title":"LabelCopilotServiceNowAdvancedConfigurationApiname","maxLength":250},"proofOfWork":{"type":"string","title":""},"includeHrsd":{"type":"boolean","title":"LabelIncludeHrsdChecks","default":false},"includeKnowledgeBlocks":{"type":"boolean","title":"LabelIncludeKnowledgeBlocksChecks","default":false},"includeAdvancedScript":{"type":"boolean","title":"LabelIncludeAdvancedScriptChecks","default":false}},"required":["connectorType","authenticationType","proofOfWork"],"dependencies":{"authenticationType":{"oneOf":[{"properties":{"authenticationType":{"enum":["Basic"]},"serviceNowUrl":{"type":"string","title":"ServiceNowUrlInstanceLabel","pattern":"^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$"},"userName":{"type":"string","title":"LabelSourceUserName","pattern":"^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$"},"password":{"type":"string","title":"LabelPassword"},"apiName":{"type":"string","title":"LabelCopilotServiceNowAdvancedConfigurationApiname","maxLength":250}},"required":["serviceNowUrl","userName","password"]},{"properties":{"authenticationType":{"enum":["OAuth"]},"clientId":{"type":"string","title":"LabelClientId"},"clientSecret":{"type":"string","title":"LabelClientSecret"},"serviceNowUrl":{"type":"string","title":"ServiceNowUrlInstanceLabel","pattern":"^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$"},"userName":{"type":"string","title":"LabelSourceUserName","pattern":"^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$"},"password":{"type":"string","title":"LabelPassword"},"apiName":{"type":"string","title":"LabelCopilotServiceNowAdvancedConfigurationApiname","maxLength":250}},"required":["clientId","clientSecret","serviceNowUrl","userName","password"]}]}},"$id":"-68cdfd15"};
const pattern0 = new RegExp("^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$", "u");
const pattern1 = new RegExp("^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$", "u");
const func2 = require("ajv/dist/runtime/ucs2length").default;

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-68cdfd15" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.connectorType === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "connectorType"},message:"must have required property '"+"connectorType"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.authenticationType === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "authenticationType"},message:"must have required property '"+"authenticationType"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.proofOfWork === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.authenticationType !== undefined){
const _errs2 = errors;
let valid1 = false;
let passing0 = null;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.serviceNowUrl === undefined){
const err3 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/0/required",keyword:"required",params:{missingProperty: "serviceNowUrl"},message:"must have required property '"+"serviceNowUrl"+"'",schema:schema11.dependencies.authenticationType.oneOf[0].required,parentSchema:schema11.dependencies.authenticationType.oneOf[0],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.userName === undefined){
const err4 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/0/required",keyword:"required",params:{missingProperty: "userName"},message:"must have required property '"+"userName"+"'",schema:schema11.dependencies.authenticationType.oneOf[0].required,parentSchema:schema11.dependencies.authenticationType.oneOf[0],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.password === undefined){
const err5 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/0/required",keyword:"required",params:{missingProperty: "password"},message:"must have required property '"+"password"+"'",schema:schema11.dependencies.authenticationType.oneOf[0].required,parentSchema:schema11.dependencies.authenticationType.oneOf[0],data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "Basic")){
const err6 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType.enum,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.serviceNowUrl !== undefined){
let data1 = data.serviceNowUrl;
if(typeof data1 === "string"){
if(!pattern0.test(data1)){
const err7 = {instancePath:instancePath+"/serviceNowUrl",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/serviceNowUrl/pattern",keyword:"pattern",params:{pattern: "^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$"},message:"must match pattern \""+"^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$"+"\"",schema:"^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$",parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.serviceNowUrl,data:data1};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/serviceNowUrl",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/serviceNowUrl/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[0].properties.serviceNowUrl.type,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.serviceNowUrl,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.userName !== undefined){
let data2 = data.userName;
if(typeof data2 === "string"){
if(!pattern1.test(data2)){
const err9 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/userName/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$"},message:"must match pattern \""+"^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$"+"\"",schema:"^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$",parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.userName,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/userName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[0].properties.userName.type,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.userName,data:data2};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.password !== undefined){
let data3 = data.password;
if(typeof data3 !== "string"){
const err11 = {instancePath:instancePath+"/password",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/password/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[0].properties.password.type,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.password,data:data3};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.apiName !== undefined){
let data4 = data.apiName;
if(typeof data4 === "string"){
if(func2(data4) > 250){
const err12 = {instancePath:instancePath+"/apiName",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/apiName/maxLength",keyword:"maxLength",params:{limit: 250},message:"must NOT have more than 250 characters",schema:250,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.apiName,data:data4};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/apiName",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/apiName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[0].properties.apiName.type,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.apiName,data:data4};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
var _valid0 = _errs3 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
}
const _errs13 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.clientId === undefined){
const err14 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "clientId"},message:"must have required property '"+"clientId"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data.clientSecret === undefined){
const err15 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "clientSecret"},message:"must have required property '"+"clientSecret"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data.serviceNowUrl === undefined){
const err16 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "serviceNowUrl"},message:"must have required property '"+"serviceNowUrl"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data.userName === undefined){
const err17 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "userName"},message:"must have required property '"+"userName"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data.password === undefined){
const err18 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "password"},message:"must have required property '"+"password"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.authenticationType !== undefined){
let data5 = data.authenticationType;
if(!(data5 === "OAuth")){
const err19 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType.enum,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType,data:data5};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.clientId !== undefined){
let data6 = data.clientId;
if(typeof data6 !== "string"){
const err20 = {instancePath:instancePath+"/clientId",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/clientId/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.clientId.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.clientId,data:data6};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.clientSecret !== undefined){
let data7 = data.clientSecret;
if(typeof data7 !== "string"){
const err21 = {instancePath:instancePath+"/clientSecret",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/clientSecret/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.clientSecret.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.clientSecret,data:data7};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.serviceNowUrl !== undefined){
let data8 = data.serviceNowUrl;
if(typeof data8 === "string"){
if(!pattern0.test(data8)){
const err22 = {instancePath:instancePath+"/serviceNowUrl",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/serviceNowUrl/pattern",keyword:"pattern",params:{pattern: "^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$"},message:"must match pattern \""+"^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$"+"\"",schema:"^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$",parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.serviceNowUrl,data:data8};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {instancePath:instancePath+"/serviceNowUrl",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/serviceNowUrl/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.serviceNowUrl.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.serviceNowUrl,data:data8};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.userName !== undefined){
let data9 = data.userName;
if(typeof data9 === "string"){
if(!pattern1.test(data9)){
const err24 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/userName/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$"},message:"must match pattern \""+"^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$"+"\"",schema:"^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$",parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.userName,data:data9};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/userName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.userName.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.userName,data:data9};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.password !== undefined){
let data10 = data.password;
if(typeof data10 !== "string"){
const err26 = {instancePath:instancePath+"/password",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/password/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.password.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.password,data:data10};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.apiName !== undefined){
let data11 = data.apiName;
if(typeof data11 === "string"){
if(func2(data11) > 250){
const err27 = {instancePath:instancePath+"/apiName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/apiName/maxLength",keyword:"maxLength",params:{limit: 250},message:"must NOT have more than 250 characters",schema:250,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.apiName,data:data11};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
else {
const err28 = {instancePath:instancePath+"/apiName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/apiName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.apiName.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.apiName,data:data11};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
var _valid0 = _errs13 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
}
}
if(!valid1){
const err29 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.authenticationType.oneOf,parentSchema:schema11.dependencies.authenticationType,data};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
}
if(data.connectorType !== undefined){
let data12 = data.connectorType;
if(typeof data12 !== "string"){
const err30 = {instancePath:instancePath+"/connectorType",schemaPath:"#/properties/connectorType/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.connectorType.type,parentSchema:schema11.properties.connectorType,data:data12};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(!(((data12 === "KB") || (data12 === "Catalog")) || (data12 === "Tickets"))){
const err31 = {instancePath:instancePath+"/connectorType",schemaPath:"#/properties/connectorType/enum",keyword:"enum",params:{allowedValues: schema11.properties.connectorType.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.connectorType.enum,parentSchema:schema11.properties.connectorType,data:data12};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data.authenticationType !== undefined){
let data13 = data.authenticationType;
if(typeof data13 !== "string"){
const err32 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.authenticationType.type,parentSchema:schema11.properties.authenticationType,data:data13};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(!((data13 === "Basic") || (data13 === "OAuth"))){
const err33 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.authenticationType.enum,parentSchema:schema11.properties.authenticationType,data:data13};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.serviceNowUrl !== undefined){
let data14 = data.serviceNowUrl;
if(typeof data14 === "string"){
if(!pattern0.test(data14)){
const err34 = {instancePath:instancePath+"/serviceNowUrl",schemaPath:"#/properties/serviceNowUrl/pattern",keyword:"pattern",params:{pattern: "^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$"},message:"must match pattern \""+"^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$"+"\"",schema:"^https:\\/\\/[a-zA-Z0-9-]+\\.service-now\\.com$",parentSchema:schema11.properties.serviceNowUrl,data:data14};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
else {
const err35 = {instancePath:instancePath+"/serviceNowUrl",schemaPath:"#/properties/serviceNowUrl/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.serviceNowUrl.type,parentSchema:schema11.properties.serviceNowUrl,data:data14};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.userName !== undefined){
let data15 = data.userName;
if(typeof data15 === "string"){
if(!pattern1.test(data15)){
const err36 = {instancePath:instancePath+"/userName",schemaPath:"#/properties/userName/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$"},message:"must match pattern \""+"^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$"+"\"",schema:"^[a-zA-Z0-9'!#~_@/^-](?:[a-zA-Z0-9'!#~_@/.^-]*[a-zA-Z0-9'!#~_@/^-])?$",parentSchema:schema11.properties.userName,data:data15};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/userName",schemaPath:"#/properties/userName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.userName.type,parentSchema:schema11.properties.userName,data:data15};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.password !== undefined){
let data16 = data.password;
if(typeof data16 !== "string"){
const err38 = {instancePath:instancePath+"/password",schemaPath:"#/properties/password/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.password.type,parentSchema:schema11.properties.password,data:data16};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data.apiName !== undefined){
let data17 = data.apiName;
if(typeof data17 === "string"){
if(func2(data17) > 250){
const err39 = {instancePath:instancePath+"/apiName",schemaPath:"#/properties/apiName/maxLength",keyword:"maxLength",params:{limit: 250},message:"must NOT have more than 250 characters",schema:250,parentSchema:schema11.properties.apiName,data:data17};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
else {
const err40 = {instancePath:instancePath+"/apiName",schemaPath:"#/properties/apiName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.apiName.type,parentSchema:schema11.properties.apiName,data:data17};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data18 = data.proofOfWork;
if(typeof data18 !== "string"){
const err41 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data18};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data.includeHrsd !== undefined){
let data19 = data.includeHrsd;
if(typeof data19 !== "boolean"){
const err42 = {instancePath:instancePath+"/includeHrsd",schemaPath:"#/properties/includeHrsd/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.includeHrsd.type,parentSchema:schema11.properties.includeHrsd,data:data19};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
if(data.includeKnowledgeBlocks !== undefined){
let data20 = data.includeKnowledgeBlocks;
if(typeof data20 !== "boolean"){
const err43 = {instancePath:instancePath+"/includeKnowledgeBlocks",schemaPath:"#/properties/includeKnowledgeBlocks/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.includeKnowledgeBlocks.type,parentSchema:schema11.properties.includeKnowledgeBlocks,data:data20};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data.includeAdvancedScript !== undefined){
let data21 = data.includeAdvancedScript;
if(typeof data21 !== "boolean"){
const err44 = {instancePath:instancePath+"/includeAdvancedScript",schemaPath:"#/properties/includeAdvancedScript/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.includeAdvancedScript.type,parentSchema:schema11.properties.includeAdvancedScript,data:data21};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
}
else {
const err45 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}

exports["-3625bd4b"] = validate11;
const schema12 = {"type":"object","properties":{"authenticationType":{"enum":["Basic"]}},"$id":"-3625bd4b"};

function validate11(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-3625bd4b" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "Basic")){
const err0 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema12.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.authenticationType.enum,parentSchema:schema12.properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.type,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate11.errors = vErrors;
return errors === 0;
}

exports["249b33cc"] = validate12;
const schema13 = {"type":"object","properties":{"authenticationType":{"enum":["OAuth"]}},"$id":"249b33cc"};

function validate12(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="249b33cc" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "OAuth")){
const err0 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema13.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema13.properties.authenticationType.enum,parentSchema:schema13.properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema13.type,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate12.errors = vErrors;
return errors === 0;
}
